import React from "react";

const PREVIEW_MAX = 80;

function getPreviewText(msg) {
    if (!msg) return "";
    if (msg.type === "text") {
        const t = msg.text || "";
        return t.length > PREVIEW_MAX ? t.slice(0, PREVIEW_MAX) + "…" : t;
    }
    if (msg.type === "photo") return "📷 Photo";
    if (msg.type === "video" || msg.type === "video_note") return "🎥 Video";
    if (msg.type === "voice" || msg.type === "audio") return "🎤 Voice message";
    if (msg.type === "document") return "📄 Document";
    return "Message";
}

export function ReplyPreview({ message, senderName, onCancel }) {
    if (!message) return null;

    return (
        <div
            style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                gap: 8,
                padding: "6px 10px",
                background: "#e8f4fd",
                borderLeft: "3px solid #1976d2",
                borderRadius: "0 6px 6px 0",
                marginBottom: 6,
                animation: "replyFadeIn 0.15s ease",
            }}
        >
            <style>{`
        @keyframes replyFadeIn {
          from { opacity: 0; transform: translateY(-4px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
            <div style={{ minWidth: 0, flex: 1 }}>
                <div
                    className="reply-preview-message-block_name"
                    style={{
                        fontSize: 12,
                        fontWeight: 600,
                        color: "#1976d2",
                        marginBottom: 2,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                >
                    ↩ {senderName}
                </div>
                <div
                    className="reply-preview-message-block"
                    style={{
                        fontSize: 12,
                        color: "#555",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                >
                    {getPreviewText(message)}
                </div>
            </div>
            <button
                onClick={onCancel}
                aria-label="Cancel reply"
                style={{
                    flexShrink: 0,
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    color: "#999",
                    fontSize: 18,
                    lineHeight: 1,
                    padding: "0 2px",
                    marginTop: 1,
                }}
            >
                ✕
            </button>
        </div>
    );
}